<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('sidebar.setting.campus.list')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <b-card :header="$t('sidebar.setting.campus.list')" header-bg-variant="light" body-class="p-0">
                    <table class="table table-hover" v-if="campuses.length">
                        <thead>
                            <th>{{$t('form.setting.partnerCampusLocation')}}</th>
                            <th>{{$t('form.setting.partnerCode')}}</th>
                            <th>{{$t('form.setting.active')}}</th>
                            <th>{{$t('form.setting.sortOrder')}}</th>
                            <th class="text-right">{{$t('form.setting.action')}}</th>
                        </thead>

                        <tbody>
                            <tr v-for="(campus,index) in campuses" :key="index"
                                @dblclick="edit(campus.PartnerCampusID)">
                                <td>{{campus.PartnerCampusLocation}}</td>
                                <td>{{campus.partner ? campus.partner.PartnerCode : null}}</td>
                                <td>
                                    <b-badge variant="success" v-if="campus.PartnerCampusActive">
                                        {{$t('form.setting.yes')}}</b-badge>
                                    <b-badge variant="danger" v-else>{{$t('form.setting.no')}}</b-badge>
                                </td>
                                <td>{{campus.PartnerCampusSortOrder}}</td>
                                <td class="text-right">
                                    <b-button variant="info" size="sm" @click="edit(campus.PartnerCampusID)"
                                        v-if="permissions.viewSettingsCampuses">
                                        <span class="fa fa-edit"></span></b-button>

                                    <b-button variant="danger" size="sm" @click="remove(campus.PartnerCampusID, index)"
                                        v-if="permissions.deleteSettingsCampuses">
                                        <span class="fa fa-trash"></span>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </b-card>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                campuses: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsCampuses) {
                return this.$router.push('/');
            }

            this.fetch();
        },

        methods: {

            paginate() {
                this.fetch();
            },

            fetch() {
                this.isLoading = true;

                axios
                    .get('/api/campuses?page=' + this.pagination.current_page)
                    .then((response) => {
                        this.campuses = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)

                        this.isLoading = false;
                    });
            },

            edit(id) {
                if (!this.permissions.viewSettingsCampuses) return;

                this.$router.push({
                    name: 'CampusEdit',
                    params: {
                        id: id
                    }
                });
            },

            remove(id, index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;

                    axios
                        .delete('/api/campuses/' + id)
                        .then(response => {
                            if (response.data.success) {
                                this.campuses.splice(index, 1);

                                this.isLoading = false;
                                this.showAlert(response.data.message);
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;

                            this.showAlert(error.response.data.message, 'danger');
                        });
                }
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
